export const brand = {
  name: "ProperHumanDiet",
  tagline: "Guided nutrition. Measured recovery.",
  description:
    "Nutrition, protocol, and recovery tracking for whole-food health routines.",
  logoAlt: "ProperHumanDiet logo",
  colors: {
    sage: "#24523f",
    amber: "#d29a32",
    offWhite: "#fbfaf6",
    nearBlack: "#18211d",
  },
  assets: {
    logoIcon: "branding/logo-icon.svg",
    logoDarkIcon: "branding/logo-dark.svg",
    logoFull: "branding/logo-full.svg",
    logoMonoBlack: "branding/logo-mono-black.svg",
    logoMonoWhite: "branding/logo-mono-white.svg",
    appleTouchIcon: "branding/apple-touch-icon-180x180.png",
    favicon: "branding/favicon.ico",
    maskableIcon: "branding/maskable-icon-512x512.png",
    pwa64: "branding/pwa-64x64.png",
    pwa192: "branding/pwa-192x192.png",
    pwa512: "branding/pwa-512x512.png",
    ogImage: "branding/og-image.png",
  },
} as const;

export function brandAssetPath(baseUrl: string, assetPath: string): string {
  return `${baseUrl}${assetPath.replace(/^\//, "")}`;
}
